import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { scrollToId, PHONE_DISPLAY, PHONE_TEL, EMAIL } from "@/lib/scroll";
import { SERVICES_DATA } from "@/data/services";

const LINKS = [
  { id: "start", label: "Startseite" },
  { id: "leistungen", label: "Leistungen" },
  { id: "ueber-uns", label: "Über uns" },
  { id: "warum-wir", label: "Warum wir" },
  { id: "kontakt", label: "Kontakt" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="mx-auto max-w-7xl px-5 md:px-8 py-16 md:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">
      <div>
        <div className="flex items-center gap-3">
          <img
            src="/assets/terbeck-logo.jpeg"
            alt="TERBECK SERVICE Logo – Gronau (Westf.)"
            className="h-12 w-12 rounded-lg object-cover ring-1 ring-white/15"
            loading="lazy"
          />
          <span className="font-display font-bold tracking-tight text-white">
            TERBECK <span className="text-brand-bright">SERVICE</span>
          </span>
        </div>
        <p className="mt-5 text-sm leading-relaxed text-white/50">
          Ihr regionaler Dienstleister rund um Haus, Grundstück und Immobilie:
          Hausmeisterservice, Reinigung, Pflege, Winterdienst und mehr in Gronau (Westf.)
          und Umgebung im Kreis Borken.
        </p>
      </div>

      <nav aria-label="Footer Navigation">
        <h4 className="mb-5 text-xs font-bold tracking-[0.25em] text-white/40">NAVIGATION</h4>
        <ul className="space-y-3">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Leistungen">
        <h4 className="mb-5 text-xs font-bold tracking-[0.25em] text-white/40">LEISTUNGEN</h4>
        <ul className="space-y-2.5">
          {SERVICES_DATA.map((s) => (
            <li key={s.slug}>
              <Link
                data-testid={`footer-service-${s.slug}`}
                to={`/${s.slug}`}
                className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
              >
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h4 className="mb-5 text-xs font-bold tracking-[0.25em] text-white/40">KONTAKT</h4>
        <ul className="space-y-4">
          <li>
            <a
              data-testid="footer-phone-link"
              href={PHONE_TEL}
              className="flex items-center gap-3 text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
            >
              <Phone className="h-4 w-4 text-brand-bright" />
              {PHONE_DISPLAY}
            </a>
          </li>
          <li>
            <a
              data-testid="footer-email-link"
              href={`mailto:${EMAIL}`}
              className="flex items-center gap-3 text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300 break-all"
            >
              <Mail className="h-4 w-4 text-brand-bright shrink-0" />
              {EMAIL}
            </a>
          </li>
          <li className="flex items-start gap-3 text-sm text-white/50">
            <MapPin className="h-4 w-4 text-brand-bright shrink-0 mt-0.5" />
            <span>
              Terbeck Service GbR<br />
              Riekenhofweg 29<br />
              48599 Gronau (Westf.)
            </span>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="mb-5 text-xs font-bold tracking-[0.25em] text-white/40">RECHTLICHES</h4>
        <ul className="space-y-3">
          <li>
            <Link
              data-testid="footer-impressum-link"
              to="/impressum"
              className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
            >
              Impressum
            </Link>
          </li>
          <li>
            <Link
              data-testid="footer-datenschutz-link"
              to="/datenschutz"
              className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
            >
              Datenschutz
            </Link>
          </li>
          <li>
            <Link
              data-testid="footer-agb-link"
              to="/agb"
              className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
            >
              AGB
            </Link>
          </li>
          <li>
            <Link
              data-testid="footer-login-link"
              to="/login"
              className="text-sm font-semibold text-white/70 hover:text-brand-bright transition-colors duration-300"
            >
              Interner Bereich
            </Link>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} Terbeck Service GbR · Gronau (Westf.) · Alle Rechte vorbehalten.
        </p>
        <p className="text-xs font-bold tracking-[0.2em] text-white/30">
          TRANSPORT · LOGISTIK · SERVICE
        </p>
      </div>
    </div>
  </footer>
);
